import SvgIcon from './SvgIcon.vue'// svg component
import { App } from 'vue'

const defaultContext = require.context('./data', false, /\.svg$/)

export const initIconConfig = function(app: App, pageContent?: __WebpackModuleApi.RequireContext) {
  // register globally
  app.component('svg-icon', SvgIcon)
  defaultContext.keys().map(defaultContext)
  if (pageContent) {
    pageContent.keys().map(pageContent)
  }
}
